import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ServerTranslatePipe } from '@app/utils/pipes/server-translate-pipe';

@Component({
  selector: 'app-user-roles-list',
  standalone: true,
  imports: [CommonModule, TranslateModule, ServerTranslatePipe],
  templateUrl: './user-roles-list.component.html',
  styleUrls: ['./user-roles-list.component.scss'],
})
export class UserRolesListComponent {
  @Input() rolesData: any[] = [];
  @Input() roleUserCounts: { [roleName: string]: { total: number; users: any[] } } = {};
  @Input() selectedRole: string | null = null;

  @Output() onSelectRole = new EventEmitter<string>();
  @Output() onShowUserInRole = new EventEmitter<{ role: any; event: MouseEvent }>();

  constructor(private translate: TranslateService) {}

  selectRole(roleId: string): void {
    this.onSelectRole.emit(roleId);
  }

  showUserInRole(role: any, event: MouseEvent): void {
    this.onShowUserInRole.emit({ role, event });
  }

  getUserCountForRole(role: any): number {
    const roleName = typeof role === 'string' ? role : role.name;
    return this.roleUserCounts[roleName]?.total || 0;
  }

  getUserCountText(count: number): string {
    const currentLang =
      (this.translate as any).store.currentLang || this.translate.currentLang || this.translate.defaultLang || 'ru';

    if (currentLang === 'ru' || currentLang === 'ru-ru' || currentLang === 'ru-RU') {
      const lastDigit = count % 10;
      const lastTwoDigits = count % 100;

      if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return 'пользователей';
      } else if (lastDigit === 1) {
        return 'пользователь';
      } else if (lastDigit >= 2 && lastDigit <= 4) {
        return 'пользователя';
      } else {
        return 'пользователей';
      }
    } else {
      return count === 1 ? 'user' : 'users';
    }
  }
}
